import { render, staticRenderFns } from "./ModalWhoIstheFavored.vue?vue&type=template&id=fa886d78&scoped=true"
import script from "./ModalWhoIstheFavored.vue?vue&type=script&lang=js"
export * from "./ModalWhoIstheFavored.vue?vue&type=script&lang=js"
import style0 from "./ModalWhoIstheFavored.vue?vue&type=style&index=0&id=fa886d78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa886d78",
  null
  
)

export default component.exports